import { ContactPageFallbackResponse } from '../fallback-data/contact-page';
import { ContactPageResponse } from '../types/contact-page';

const STRAPI_URL =
  process.env.NEXT_PUBLIC_STRAPI_URL || 'http://localhost:1337';

export const fetchContactPage = async (): Promise<ContactPageResponse> => {
  try {
    const response = await fetch(`${STRAPI_URL}/api/contact-page`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      console.error('Error fetching contact page:', response.statusText);
      return ContactPageFallbackResponse;
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching contact page:', error);
    return ContactPageFallbackResponse;
  }
};
